import React, { useContext } from 'react';
import { map } from 'underscore';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Pivot, PivotItem } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getPivotContainerStyle } from './pivot-container-style';

export const AssetLibraryAddMediaPivotContainer = (props) => {
  const { selectedKey, setSelectedKey, addMediaConfig } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getPivotContainerStyle);

  return (
    <Pivot
      className={classnames('add-media-container', classes.addMediaContainer)}
      selectedKey={selectedKey}
      onLinkClick={(item) => {
        setSelectedKey(item.props.itemKey);
      }}
      styles={{
        itemContainer: {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          '& > div': { // there's a magic div that exists underneath PivotItem root container for which
            // FluentUI doesn't expose a styling interface
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
          },
        },
      }}
    >
      {map(addMediaConfig, ({ title, onRenderTab, key }) => (
        <PivotItem
          headerText={i18n.getString(title)}
          itemKey={key}
          key={key}
        >
          <div className={classnames(classes.pivotContentContainer, `add-media-tab-${key}`)}>
            {onRenderTab({
              ...props,
              classes,
            })}
          </div>
        </PivotItem>
      ))}
    </Pivot>
  );
};

AssetLibraryAddMediaPivotContainer.propTypes = {
  selectedKey: PropTypes.string,
  setSelectedKey: PropTypes.func.isRequired,
  logger: PropTypes.shape({}).isRequired,
  addMediaConfig: PropTypes.arrayOf(PropTypes.shape({})),
};

AssetLibraryAddMediaPivotContainer.defaultProps = {
  selectedKey: undefined,
  addMediaConfig: [],
};
